module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/default-45042836be6d4d6c089cf702eae30106.jpg";